module.exports = __webpack_public_path__ + "1ddb7d37ca5dd926ae55bf302f3f30eb.png";